module.exports = __webpack_public_path__ + "img/Ad-Banner-slide-1.0e991697.jpg";